import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewAmenitiespageNews from "../../components/Amenities/ViewAmenitiesLayer";



const ViewPromotion= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Amenities" title2="Amenities" link2="/amenities" />

        {/* AddUserLayer */}
        <ViewAmenitiespageNews />


      </MasterLayout>
    </>
  );
};

export default ViewPromotion;
